if (!customElements.get('size-chart-slot')) {
  customElements.define(
    'size-chart-slot',
    class SizeChartSlot extends HTMLElement {
      connectedCallback() {
        this.productInfoElement = this.closest('[data-product-info]');
        if (!this.productInfoElement) return;

        this.isPrimary = this.productInfoElement.querySelector('size-chart-slot') === this;
        if (!this.isPrimary) {
          this.addEventListener('click', this.openSizeChart.bind(this));
          this.addEventListener('keydown', this.onKeyDown.bind(this));
        }

        this.mutationObserver = new MutationObserver(() => this.adoptSizeChart());
        this.mutationObserver.observe(this.productInfoElement, { childList: true, subtree: true });
        this.mutationObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        this.adoptSizeChart();
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
      }

      adoptSizeChart() {
        if (!document.documentElement.classList.contains('pdp-info-visible')) return;

        if (this.isPrimary) {
          const sizeChartElement = [...this.productInfoElement.querySelectorAll('.ks-chart-container')].find(
            (chartElement) => !chartElement.closest('size-chart-slot')
          );
          if (sizeChartElement) this.replaceChildren(sizeChartElement);
          return;
        }

        if (this.childElementCount > 0) return;

        const primarySizeChartElement = this.productInfoElement.querySelector('size-chart-slot .ks-chart-container');
        if (!primarySizeChartElement) return;

        this.replaceChildren(primarySizeChartElement.cloneNode(true));
      }

      onKeyDown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        this.openSizeChart();
      }

      openSizeChart() {
        this.productInfoElement.querySelector('size-chart-slot .ks-chart-modal-link')?.click();
      }
    }
  );
}

if (!customElements.get('fit-quiz-trigger')) {
  customElements.define(
    'fit-quiz-trigger',
    class FitQuizTrigger extends HTMLElement {
      connectedCallback() {
        this.buttonElement = this.querySelector('[data-fit-quiz-button]');
        if (!this.buttonElement) return;

        this.buttonElement.addEventListener('click', () => document.getElementById('easysize_button')?.click());
      }
    }
  );
}
